import find from "lodash/fp/find";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";

export default function selectProductHeaderProps(state) {
  const { selectedProductId } = state.app;

  return flow(
    getOr([], ["app", "formData", "products"]),
    find(({ id }) => id === selectedProductId),
    getOr({}, ["category", "productHeaderProps"])
  )(state);
}
